import Inspector from './inspector';
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, setAttributes }) => {
  const {
    text,
    containerized,
    align,
    color,
    margin,
    removeMarker,
    maxWidth,
    fontWeight,
  } = attributes;
  const ALLOWED_BLOCKS = ['core/list', 'app/grid-button'];

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div
        className={`only-text paragraph-block ${color} ${
          removeMarker ? 'removeMarker' : ''
        } ${maxWidth}`}
      >
        <div
          className={`only-text__content ${
            containerized ? 'Container' : ''
          } ${margin}`}
        >
          <RichText
            tagName="p"
            selector="p"
            className={`Typography text ${align}  ${fontWeight}`}
            value={text}
            placeholder="Texto (tag p)"
            keepPlaceholderOnFocus
            onChange={(text) => setAttributes({ text })}
          />

          <InnerBlocks allowedBlocks={ALLOWED_BLOCKS} />
        </div>
      </div>
    </>
  );
};
